import { Container, Image } from 'react-bootstrap';

function App() {
    return (
      <Container>
        <div style={{"display": "flex", "justifyContent": "center", "alignItems": "center"}}>
            <div style={{"maxWidth": "30%", "textAlign": "center"}}>
                <Image src='crane_sm.png' className='' />
                <h5 className='notification'><br/><br/>Sorry. Nothing found</h5>
            </div>
        </div>
      </Container>
    );
  }
  
  export default App;